import { pm } from '@renderer/modules/api/pm';
import type { ApiResponse, TradeActivity } from '@renderer/modules/types';

export async function getMarketActivity(opts?: { limit?: number }): Promise<ApiResponse<TradeActivity[]>> {
  return pm.getMarketActivity(opts);
}


